import React, {Component} from 'react';

import PropTypes    from 'prop-types';

import { withRouter} from 'react-router-dom' ;

import { withStyles } from '@material-ui/core/styles';

import withMobileDialog from '@material-ui/core/withMobileDialog';

import Button           from '@material-ui/core/Button'
import Dialog           from '@material-ui/core/Dialog'
import DialogActions    from '@material-ui/core/DialogActions'

import slideUp from '../../transitions/slideUp'

import i18n from '../../locale/fr'

import MapBoxGL from '../../components/maps/MapBoxGL'

import Place from '../../things/Place'

import settings from '../../configs/views/map'

import map from '../../datas/map' ;

const styles = () =>({});

class Map extends Component
{
    map = null ;

    state =
    {
        datas : [ ...map ] ,
        open  : false ,
        place : null
    };

    closeDialog = () =>
    {
        this.setState( { ...this.state , image : false , open : false , place : null  } )
    };

    openDialog = ( place ) =>
    {
        this.setState( { ...this.state , open : true , place : place } )
    };

    populate( datas )
    {
        if( datas instanceof Array )
        {
            datas = datas.map( element => element instanceof Place ? element : new Place(element) ) ;
        }
        return datas ;
    }

    render()
    {
        const { fullScreen , locale } = this.props ;

        let { datas , open , place } = this.state ;

        let image ;

        datas = this.populate( datas ) ;

        if( place instanceof Place )
        {
            image = (
                <img
                    className="relative p-0 m-0"
                    style  = {{ display : 'absolute' , backgroundColor : '#00102E' }}
                    src    = { './assets/images/places/' + place.image }
                    alt    = { place instanceof Place ? place.name : '' }
                />
            );
        }

        return (
            <div className="w-full h-full">
                <MapBoxGL
                    ref              = { ( ref ) => this.map = ref }
                    fly              = { true }
                    fullscreenMode   = { false }
                    gpsFixed         = { true }
                    locale           = { locale.map }
                    //onReady          = { () => console.log( this + ' map ready') }
                    onSelect         = { this.select }
                    marker           = { false }
                    markerDraggable  = { false }
                    markerMove       = { ( latitude , longitude ) => console.log( latitude , longitude ) }
                    places           = { datas }
                    accessToken      = { settings.accessToken }
                    style            = { settings.style }
                    spotUrl          = './assets/images/spots/'
                />
                <Dialog
                    fullScreen          = { fullScreen }
                    //fullWidth           = { true }
                    open                = { open }
                    onClose             = { this.closeDialog }
                    PaperProps          = {{ square : true , style : { backgroundColor : "#acc9eb" , padding : 0 } }}
                    TransitionComponent = { slideUp }
                >
                    <div style={{ minHeight : 200 }}>
                        { image }
                    </div>
                    <div style={{ color : '#2a4b9b' , padding : "20px 25px 8px 25px"}} className="font-white font-semibold text-3xl faune">{ place instanceof Place ? place.name : '' }</div>
                    <div style={{ color : '#2a4b9b' , padding : "8px 25px 20px 25px"}} className="font-white text-base faune text-justify">{ place instanceof Place ? place.description : '' }</div>
                    <DialogActions>
                        <Button style={{ backgroundColor : '#2a4b9b' }}onClick={ this.closeDialog } color="primary" variant="contained">{ locale.close }</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }

    select = ( place ) =>
    {
        this.openDialog( place ) ;
    }
}

Map.defaultProps =
{
    fullScreen : false ,
    locale : i18n.map
};

Map.propTypes =
{
    classes: PropTypes.object.isRequired,
    fullScreen : PropTypes.bool.isRequired ,
};

export default withMobileDialog()( withStyles( styles )( withRouter(Map) ) );


// WEBPACK FOOTER //
// ./src/app/views/map/Map.js